<div class="modal-header" id="add-time-recording-entry-p40-modal-title">
    <h3 class="modal-title" id="modal-title">{{ title }}</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div [formGroup]="addEntryForm">
        <fieldset class="mb-4">
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_TIME_RECORDING_P40_DATE_LABEL"></label>
                <div class="col-4">
                    <pace-core-date-input
                        [parentForm]="addEntryFormChildren"
                        [(model)]="entry.startDate"
                        [ariaLabel]="'CONFIRMATION_TIME_RECORDING_P40_DATE_LABEL' | translate"
                    >
                    </pace-core-date-input>
                </div>
                <label class="col-2 col-form-label" translate="CONFIRMATION_TIME_RECORDING_P40_DURATION_LABEL"></label>
                <div class="col-4">
                    <pace-core-duration-stepper
                        [parentForm]="addEntryFormChildren"
                        [(model)]="entry.duration"
                        [ariaLabel]="'CONFIRMATION_TIME_RECORDING_P40_DURATION_LABEL' | translate"
                    >
                    </pace-core-duration-stepper>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_TIME_RECORDING_P40_CATEGORY_LABEL"></label>
                <div class="col-4">
                    <pace-core-dropdown [parentForm]="addEntryFormChildren" [(model)]="entry.category">
                    </pace-core-dropdown>
                </div>
                <label
                    class="col-2 col-form-label"
                    translate="CONFIRMATION_TIME_RECORDING_P40_DELIVERY_TYPE_LABEL"
                ></label>
                <div class="col-4">
                    <pace-core-dropdown [parentForm]="addEntryFormChildren" [(model)]="entry.delivery">
                    </pace-core-dropdown>
                </div>
            </div>
            <div class="row mb-3">
                <label
                    class="col-2 col-form-label"
                    translate="CONFIRMATION_TIME_RECORDING_P40_BOOKING_CATEGORY_LABEL"
                ></label>
                <div class="col-4">
                    <pace-core-dropdown [parentForm]="addEntryFormChildren" [(model)]="entry.bookingCategory">
                    </pace-core-dropdown>
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-2 col-form-label" translate="CONFIRMATION_TIME_RECORDING_P40_COMMENT_LABEL"></label>
                <div class="col-10">
                    <pace-core-text-input
                        [(model)]="entry.comments"
                        [parentForm]="addEntryFormChildren"
                        [ariaLabel]="'CONFIRMATION_TIME_RECORDING_P40_COMMENT_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        </fieldset>
    </div>
</div>
<div class="modal-footer">
    <button
        [disabled]="addEntryForm.invalid"
        class="btn btn-primary"
        type="button"
        (click)="saveEntry()"
        translate="CONFIRMATION_TIME_RECORDING_P40_SAVE_ENTRY_LABEL"
    ></button>
</div>
